import React from 'react';
import { Link } from 'react-router-dom';
import footerImg from '../resource/dots-logo.png';
import '../css/Footer.css';
const Footer = () => {
    return (
        <>

            <footer class="page-footer font-small   " style={{ background: "#04091E", overflow: "hidden"}}>

                <div class="container text-center text-md-left py-3">
                    <div class="row py-4">
                        <div class="col-md-3 mx-auto text-left">
                            <h5 class="font-weight-bold text-uppercase mt-3 mb-4">Quick links</h5>
                            <ul class="list-unstyled">
                                <li className="my-3 letter-dis-1  ">
                                    <Link to="/home" className="text-decoration-none orange-hover position-relative">Home</Link>
                                </li>
                                <li className="my-3 letter-dis-1 ">
                                    <Link to="/home" className="text-decoration-none orange-hover position-relative">Prospectus</Link>
                                </li>
                                <li className="my-3 letter-dis-1 ">
                                    <Link to="/home" className="text-decoration-none orange-hover position-relative">About Us</Link>
                                </li>
                                <li className="my-3 letter-dis-1 ">
                                    <Link to="/home" className="text-decoration-none orange-hover position-relative">Contact Us</Link>
                                </li>
                                <li className="my-3 letter-dis-1 ">
                                    <Link to="/home" className="text-decoration-none orange-hover position-relative">Terms of Services</Link>
                                </li>
                            </ul>

                        </div>

                        <hr class="clearfix w-100 d-md-none " />

                        <div class="col-md-3 mx-auto text-left">

                            <h5 class="font-weight-bold text-uppercase mt-3 mb-4">Features</h5>

                            <ul class="list-unstyled ">
                                <li className="my-3 letter-dis-1  ">
                                    <Link to="/home" className="text-decoration-none orange-hover position-relative ">Home</Link>
                                </li>
                                <li className="my-3 letter-dis-1 ">
                                    <Link to="/home" className="text-decoration-none orange-hover position-relative">Jobs</Link>
                                </li>
                                <li className="my-3 letter-dis-1 ">
                                    <Link to="/home" className="text-decoration-none orange-hover position-relative">Events</Link>
                                </li>
                                <li className="my-3 letter-dis-1 ">
                                    <Link to="/home" className="text-decoration-none orange-hover position-relative">Course</Link>
                                </li>
                                <li className="my-3 letter-dis-1 ">
                                    <Link to="/home" className="text-decoration-none orange-hover position-relative">Organisations</Link>
                                </li>

                            </ul>

                        </div>

                        <hr class="clearfix w-100 d-md-none" />

                        <div class="col-md-3 mx-auto text-left">

                            <h5 class="font-weight-bold text-uppercase mt-3 mb-4">Contact Info</h5>
                            <div className="white-3">
                                <p><img style={{width:"30px"}} src="https://img.icons8.com/color/48/000000/india-circular.png"/> TBI, Block-3A, Mohali , India(140413)</p>
                                <p><img style={{width:"30px"}} src="https://img.icons8.com/color/48/000000/france-circular.png"/> Gare du Nord, Paris, France (75018)</p>
                                <p ><ion-icon name="logo-whatsapp" style={{ fontSize: "21px" }}></ion-icon>&#160;+91 7582055751 (India)</p>
                                <p ><ion-icon name="call-outline" style={{ fontSize: "21px" }}></ion-icon>&#160;+33 766737874 (France)</p>
                                <a href="mailto:info@dotsforall.com" className="text-decoration-none orange-hover position-relative"> <i class="lni lni-envelope" style={{ fontSize: "21px" }}></i>&#160; info@dotsforall.com</a>
                            </div>

                        </div>

                        <hr class="clearfix w-100 d-md-none" />

                        <div class="col-md-3 mx-auto text-left">

                            <h5 class="font-weight-bold text-uppercase  mt-3 mb-4">Newsletter</h5>

                            <p className="white-3">Stay update with our latest</p>
                            <input type="email" className="email " placeholder="Enter your email" name="" id="" />
                            <input type="submit" className="btn btn-deep-orange text-white brn-sm" style={{}} value="→" />
                            
                            <img className="mt-4 " src={footerImg} alt="logo" />

                        </div>
                    </div>

                </div>

                <div class="footer-copyright p-3 d-flex justify-content-evenly" >

                    <p className=''>
                        Copyright ©2022 All rights reserved |Design and developed by
                        <a className="text-decoration-none letter-dis-2 orange-text" href="https://edu.dotsforall.com/"> DOTS</a>
                    </p>
                    <div className="socials">
                    <a className='mx-2 white-text' href="https://www.facebook.com/3000DOTS"  style={{ fontSize: "21px" }}><i class="lni lni-facebook"></i></a>

                    <a className='mx-2 white-text' href="https://www.facebook.com/3000DOTS" style={{ fontSize: "21px" }}><i class="lni lni-twitter"></i></a>

                    <a className='mx-2 white-text' href="https://www.facebook.com/3000DOTS"  style={{ fontSize: "21px" }}><i class="lni lni-instagram-original"></i></a>

                    <a className='mx-2 white-text' href="https://www.facebook.com/3000DOTS"  style={{ fontSize: "21px" }}><i class="lni lni-youtube"></i></a>

                    <a className='mx-2 white-text' href="https://www.facebook.com/3000DOTS"  style={{ fontSize: "21px" }}><i class="lni lni-linkedin"></i></a>

                </div>
                </div>

            </footer>


        </>
    );
};

export default Footer;